var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF4724"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.143a.3.3 0 0 0-.255.148L5.61 15.846a.3.3 0 0 0 0 .296l3.743-2L12 9.427zm6.389 10.703L12.256 5.29A.3.3 0 0 0 12 5.143v4.285l2.64 4.723l3.75 1.992a.3.3 0 0 0-.001-.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.389 16.148l-3.746-2.005H9.357l-3.746 2.005a.3.3 0 0 0 .108.1a.3.3 0 0 0 .148.038H18.13a.3.3 0 0 0 .149-.037a.3.3 0 0 0 .109-.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat);
export default __webpack_public_path__ + "static/media/bat.d55619f908b0aca465fc83be49b49fa8.svg";
export { ForwardRef as ReactComponent };